import {getAncestorCombinedNode} from "@/composables/newUtils.js";
export function washData_textParagraph(walkedNode) {
  var ancestorCombinedNode = getAncestorCombinedNode(walkedNode)
  if(!ancestorCombinedNode){
    walkedNode._isEnhanceTextOverFlow = true
  }
}
